export default {
  "signin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ログイン"])},
  "signout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["サインアウト"])},
  "in_progress": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["進行中の作業..."])},
  "loading_ai": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["人工知能の読み込み..."])},
  "feed": {
    "background_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["カメラが機能していない場合は、メニュー ボタンを押してください"])},
    "back_to_camera": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["カメラに戻る"])},
    "screenshot": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["スクリーンショットを撮る"])},
    "full_screen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["全画面表示"])}
  },
  "angles": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["角度"])},
    "tabs": {
      "bones": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["スケルトン"])},
      "joints": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["関節"])},
      "figure": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["シルエット"])}
    },
    "bones": {
      "head": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["頭"])},
      "neck_lateral": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["首 ( 横方向 )"])},
      "shoulders_tilt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["肩 ( 傾斜 )"])},
      "left_upper_arm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["左上腕"])},
      "left_forearm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["左前腕"])},
      "left_side": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["左側"])},
      "right_upper_arm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["右上腕"])},
      "right_forearm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["右前腕"])},
      "right_side": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["右側"])},
      "hips_tilt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ヒップ ( 傾斜 )"])},
      "left_thigh": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["左もも"])},
      "left_calf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["左ふくらはぎ"])},
      "right_thigh": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["右もも"])},
      "right_calf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["右ふくらはぎ"])}
    },
    "joints": {
      "left_shoulder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["左肩"])},
      "right_shoulder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["右肩"])},
      "left_elbow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["左肘"])},
      "right_elbow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["右肘"])},
      "left_hip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["左腰"])},
      "right_hip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["右腰"])},
      "left_knee": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["左膝"])},
      "right_knee": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["右膝"])}
    },
    "buttons": {
      "swap_arches": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アーチを回す"])},
      "target": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["目標"])},
      "draw_joint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["関節を描く"])}
    }
  },
  "videos": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ビデオ"])},
    "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ビデオ / 画像"])},
    "tabs": {
      "videos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ビデオ"])},
      "images": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["画像"])}
    },
    "upload": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ビデオをアップロードする"])},
    "upload_image": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["画像をアップロード"])},
    "analyse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["分析する"])},
    "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ダウンロード"])}
  },
  "support": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["サポート"])}
  },
  "settings": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["設定"])},
    "tabs": {
      "profile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["プロフィール"])},
      "general": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["全般的"])},
      "ai": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ai"])}
    }
  }
}